import {
  ActionIcon,
  Badge,
  Button,
  Checkbox,
  Combobox,
  InputBase,
  Notification,
  Pill,
  RangeSlider,
  Slider,
  ThemeIcon,
  createTheme,
  rem
} from '@mantine/core';
import { DEFAULT_THEME } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import actionIconClasses from '@components/ActionButton/index.module.css';
import badgeClasses from '@components/Badge/index.module.css';
import buttonClasses from '@components/Button/index.module.css';
import comboBoxClasses from '@components/ComboBox/index.module.css';
import checkboxClasses from '@components/FormCheckbox/index.module.css';
import inputBaseClasses from '@components/InputBase/index.module.css';
import notificationClasses from '@components/Notification/index.module.css';
import notificationsClasses from '@components/Notification/notifications.module.css';
import pillClasses from '@components/Pill/index.module.css';
import rangeSliderClasses from '@components/RangeSlider/index.module.css';
import sliderClasses from '@components/Slider/index.module.css';
import themeIconClasses from '@components/ThemeIcon/index.module.css';

import colors from './colors';

const d1Theme = createTheme({
  focusRing: 'auto',
  scale: 1,
  fontSmoothing: false,
  primaryColor: 'primary',
  autoContrast: false,
  luminanceThreshold: 0,
  fontFamily: 'Inter',
  headings: {
    fontFamily: 'Inter',
    fontWeight: '700',
    textWrap: 'wrap',
    sizes: {
      h1: { fontSize: rem(34), lineHeight: '1.3' },
      h2: { fontSize: rem(26), lineHeight: '1.35' },
      h3: { fontSize: rem(22), lineHeight: '1.4' },
      h4: { fontSize: rem(18), lineHeight: '1.45' },
      h5: { fontSize: rem(16), lineHeight: '1.5' },
      h6: { fontSize: rem(14), lineHeight: '1.5' }
    }
  },
  fontSizes: {
    xs: rem(12),
    sm: rem(14),
    md: rem(16),
    lg: rem(18),
    xl: rem(20)
  },

  lineHeights: {
    xs: '1.4',
    sm: '1.45',
    md: '1.55',
    lg: '1.6',
    xl: '1.65'
  },

  radius: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(16),
    xl: rem(32)
  },

  spacing: {
    xs: rem(10),
    sm: rem(12),
    md: rem(16),
    lg: rem(20),
    xl: rem(32)
  },

  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '88em'
  },

  defaultRadius: 0,

  shadows: {
    xs: `0 ${rem(1)} ${rem(3)} rgba(0, 0, 0, 0.05), 0 ${rem(1)} ${rem(
      2
    )} rgba(0, 0, 0, 0.1)`,
    sm: `0 ${rem(1)} ${rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem(
      10
    )} ${rem(15)} ${rem(-5)}, rgba(0, 0, 0, 0.04) 0 ${rem(7)} ${rem(7)} ${rem(
      -5
    )}`,
    md: `0 ${rem(1)} ${rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem(
      20
    )} ${rem(25)} ${rem(-5)}, rgba(0, 0, 0, 0.04) 0 ${rem(10)} ${rem(10)} ${rem(
      -5
    )}`,
    lg: `0 ${rem(1)} ${rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem(
      28
    )} ${rem(23)} ${rem(-7)}, rgba(0, 0, 0, 0.04) 0 ${rem(12)} ${rem(12)} ${rem(
      -7
    )}`,
    xl: `0 ${rem(1)} ${rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem(
      36
    )} ${rem(28)} ${rem(-7)}, rgba(0, 0, 0, 0.04) 0 ${rem(17)} ${rem(17)} ${rem(
      -7
    )}`
  },

  respectReducedMotion: false,
  cursorType: 'default',
  primaryShade: 6,
  white: '#fff',
  black: '#000',
  colors: colors,
  variantColorResolver: DEFAULT_THEME.variantColorResolver,
  fontFamilyMonospace: '',
  defaultGradient: DEFAULT_THEME.defaultGradient,
  components: {
    Badge: Badge.extend({ classNames: badgeClasses }),
    Button: Button.extend({
      classNames: buttonClasses
    }),
    ActionIcon: ActionIcon.extend({
      classNames: actionIconClasses
    }),
    Checkbox: Checkbox.extend({
      classNames: checkboxClasses
    }),
    Combobox: Combobox.extend({
      classNames: comboBoxClasses
    }),
    InputBase: InputBase.extend({
      classNames: inputBaseClasses
    }),
    Pill: Pill.extend({
      classNames: pillClasses
    }),
    ThemeIcon: ThemeIcon.extend({
      classNames: themeIconClasses
    }),
    Notification: Notification.extend({
      classNames: notificationClasses
    }),
    Notifications: Notifications.extend({
      classNames: notificationsClasses
    }),
    Slider: Slider.extend({
      classNames: sliderClasses
    }),
    RangeSlider: RangeSlider.extend({
      classNames: rangeSliderClasses
    })
  },
  other: DEFAULT_THEME.other
});

export default d1Theme;
